/*
  Kremi vitrin (10-12): bölümler görünür alana girerken aynı hareketle belirir — sayfa
  parça parça değil tek akış gibi okunur. Kurallar:
    • Yükleme anında zaten ekranda olan bölümlere DOKUNULMAZ (ilk boya/LCP gecikmez,
      yanıp sönme olmaz).
    • Hareket tercihini kapatan kullanıcıda hiç çalışmaz.
    • Belirme bitince sınıf KALDIRILIR: transform kalıcı kalırsa içerideki sticky/fixed
      öğelerin konumlanmasını bozardı.
  Stil: kremi-vitrin.css (.kremi-reveal / .is-revealed).
*/
// Hareket azaltma (10-17, WCAG 2.2.2). Kayan şeritler CSS'te durur (kremi-vitrin.css — !important kuralı Prestige
// <marquee-text>'in Motion animasyonunu da bastırır; şerit sayfa altında görünür olunca başladığı için yükleme
// anındaki betik onu yakalayamıyordu). Videolar: kullanıcı kendisi başlatmadıkça oynamaz (açılış slaytı kendi
// betiğiyle play() çağırıyor — kremi-lazy-video yolunun dışında); oynat kontrolü görünür olur.
(() => {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mq.matches) return;
  const userStarted = new WeakSet();
  document.addEventListener('pointerdown', (e) => {
    const v = e.target.closest && e.target.closest('video');
    if (v) userStarted.add(v);
  }, true);
  const hold = (v) => {
    if (!(v instanceof HTMLVideoElement) || userStarted.has(v)) return;
    v.pause();
    v.controls = true;
  };
  document.addEventListener('play', (e) => hold(e.target), true);
  // Bu betik (defer) yüklenmeden önce başlamış olanlar.
  const holdPlaying = () => document.querySelectorAll('video').forEach((v) => { if (!v.paused) hold(v); });
  holdPlaying();
  window.addEventListener('load', holdPlaying);
})();

(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const sections = [...document.querySelectorAll('#main > .shopify-section')];
  const viewportBottom = window.innerHeight;

  const targets = sections.filter((section) => {
    if (section.offsetHeight < 40) return false;
    return section.getBoundingClientRect().top > viewportBottom * 0.9;
  });

  if (targets.length === 0) return;

  const cleanup = (section) => {
    section.classList.remove('kremi-reveal', 'is-revealed');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const section = entry.target;
        observer.unobserve(section);
        section.classList.add('is-revealed');
        setTimeout(() => cleanup(section), 1200);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  targets.forEach((section) => {
    section.classList.add('kremi-reveal');
    observer.observe(section);
  });
})();
